import { connect } from 'react-redux';
import ResetPatientsPassword from 'components/EditPatientsInformation/ResetPatientsPassword';

import { patientSubmitChangePasswordForm } from 'store/actionCreators/patient';

const mapDispatchToProps = (dispatch, { patientId }) => ({
  onSubmit: () => dispatch(patientSubmitChangePasswordForm({ patientId })),
});

export default connect(
  null,
  mapDispatchToProps,
)(ResetPatientsPassword);
